import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseCreateEstablishmentLeadGenericDocumentProps {
  establishmentLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useCreateEstablishmentLeadGenericDocument = ({ establishmentLeadId, onSuccess, onError }: UseCreateEstablishmentLeadGenericDocumentProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['createEstablishmentLeadGenericDocument'],
    mutationFn: (data: { blob_id: string }) => {
      const lead = {
        generic_documents_attachments_attributes: [
          {
            blob_id: data.blob_id,
          }
        ]
      }

      return privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}